import type { GestorDashboardBreakdownRow, GestorDashboardTimeEntry } from '@/components/Gestores/gestorDashboardTypes'
import {
  buildExecutorTaskRows,
  summarizeExecutorEntries,
} from '@/components/Gestores/gestorDashboardExecutorUtils'

export { buildExecutorTaskRows as buildClientScopeTaskRows, summarizeExecutorEntries as summarizeClientScopeEntries }

export function aggregateClientScopeBreakdown(
  entries: GestorDashboardTimeEntry[],
  pick: (entry: GestorDashboardTimeEntry) => { key: string; label: string } | null,
): GestorDashboardBreakdownRow[] {
  const map = new Map<string, GestorDashboardBreakdownRow>()

  for (const entry of entries) {
    const picked = pick(entry)
    if (!picked) continue
    const current = map.get(picked.key) ?? { ...picked, effortMinutes: 0 }
    current.effortMinutes += entry.effortMinutes
    map.set(picked.key, current)
  }

  return [...map.values()].sort((a, b) => b.effortMinutes - a.effortMinutes)
}
